<template>
  <div id="feedbackDialog" v-if="feedbackState.shown" @keyup="onKeyup">
    <div :class="feedbackModalClass">
      <div class="modal-content">
        <div class="ww-close-icon">
          <img
            src="https://io.winwinapp.ru/images/close.svg"
            @click="closeDialog"
          />
        </div>
        <div :class="modalBodyClass">
          <form v-if="!isSended" ref="form">
            <div class="position-relative input-component">
              <span class="ww-label"
                >{{ applicationName }}:<span style="color: red">*</span></span
              >
              <input
                v-model="name"
                type="text"
                id="name"
                name="name"
                class="input-component__input ww-input input-component__input--required"
              />
            </div>
            <div class="position-relative input-component">
              <span class="ww-label"
                >{{ applicationPhone }}:<span style="color: red">*</span></span
              >
              <input
                v-model="phone"
                type="number"
                id="phone"
                name="phone"
                class="input-component__input ww-input input-component__input--required"
              />
            </div>
            <div class="position-relative input-component">
              <span class="ww-label">{{ applicationComment }}:</span>
              <textarea
                v-model="comment"
                id="comment"
                class="input-component__input ww-input input-component__input--textarea"
              />
            </div>
          </form>
          <div v-else>
            <div v-if="isError">{{ somethingWentWrong }}</div>
            <div v-else>{{ applicationHasBeenSent }}</div>
          </div>
        </div>

        <div v-if="!isSended" class="modal-footer modal-footer--ww">
          <div
            id="feedback-dialog-button"
            class="main-button main-button--modal"
            :class="modalBtnClass"
            @click="submitFeedbackHandler"
          >
            {{ signUpForViewing }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref } from 'vue'
import api from '../../../services/api.js'
import Locale from '../../../services/locale'
import { metrikaEvents } from '../../../services/metrika'

const getUtmParams = () => {
  const currentUrl = new URL(window.location.href)
  const utm = {}
  Array.from(currentUrl.searchParams).forEach(([param, value]) => {
    if (!param.includes('utm')) return
    utm[param] = value
  })
  return utm
}

export default {
  name: 'FeedbackModal',
  props: {
    feedbackState: Object,
    localeService: Locale,
    presentationId: String,
  },
  setup() {
    const name = ref('')
    const phone = ref('')
    const comment = ref('')
    const isError = ref(false)
    const isSended = ref(false)

    return {
      name,
      phone,
      comment,
      isError,
      isSended,
    }
  },
  computed: {
    feedbackModalClass() {
      return {
        'feedback-modal': true,
        'feedback-modal--sended': this.isSended,
      }
    },
    modalBodyClass() {
      return {
        'modal-body': true,
        'mt-1': !this.isSended,
        'modal-body--sended': this.isSended,
      }
    },
    modalBtnClass() {
      return {
        'main-button--modal-disabled': !this.checkValidity,
      }
    },
    applicationName() {
      return this.localeService.getConstantTranslationByKey('application-name')
    },
    applicationPhone() {
      return this.localeService.getConstantTranslationByKey('application-phone')
    },
    applicationComment() {
      return this.localeService.getConstantTranslationByKey(
        'application-comment',
      )
    },
    somethingWentWrong() {
      return this.localeService.getConstantTranslationByKey(
        'something-went-wrong',
      )
    },
    applicationHasBeenSent() {
      return this.localeService.getConstantTranslationByKey(
        'application-has-been-sent',
      )
    },
    signUpForViewing() {
      return this.localeService.getConstantTranslationByKey(
        'sign-up-for-viewing',
      )
    },
    checkValidity() {
      const body = {
        id: this.feedbackState.leadId,
        leadName: this.feedbackState.leadName,
      }

      const inputs = ['name', 'phone', 'comment']
      let isError = false
      inputs.forEach((inputName) => {
        if (!this[inputName] && inputName !== 'comment') {
          isError = true
          return
        }
        body[inputName] = this[inputName]
      })

      return !isError && body
    },
  },
  methods: {
    closeDialog() {
      this.name = ''
      this.phone = ''
      this.comment = ''
      this.isError = false
      this.isSended = false
      this.$emit('closeFeedbackModal')
    },
    submitFeedbackHandler() {
      const body = this.checkValidity
      if (!body) return
      metrikaEvents.onSendFeedback()
      this.isSended = true
      setTimeout(() => {
        this.closeDialog()
      }, 2000)
      api
        .sendFeedback({
          domain: this.feedbackState.domain,
          pId: this.presentationId,
          body: {
            ...body,
            utm: getUtmParams(),
          },
        })
        .catch((e) => {
          console.error(e)
          this.isError = true
        })
    },
    onKeyup({ keyCode }) {
      if (keyCode !== 13) {
        return
      }

      this.submitFeedbackHandler()
    },
  },
}
</script>

<style scoped>
.feedback-modal {
  width: 30vw;
  background-color: #fbfbfb;
  padding: 10px;
  border-radius: 0.2rem;
}
.feedback-modal--sended {
  background-color: #eaeaea;
  width: 16vw;
}
.modal-footer--ww {
  justify-content: center;
  padding-bottom: 0.9rem;
}
.ww-label {
  font-size: 0.8em;
  margin-left: 0.5rem;
}
.ww-input {
  background-color: #eaeaea;
  color: black;
}
.modal-body--sended {
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 400;
  font-size: 1.3em;
}

.main-button--modal-disabled {
  background-color: #cacccd;
  cursor: auto;
}

.main-button--modal-disabled:hover {
  background-color: #cacccd;
}

.ww-close-icon {
  display: flex;
  justify-content: end;
  cursor: pointer;
}
.ww-close-icon > img {
  width: 30px;
}
</style>
